import React from 'react';

const Payment = () => {
    return (
        <div style={{ fontFamily: 'cursive' }}>
            <h2>Payment System Coming Soon!!</h2>
        </div>
    );
};

export default Payment;